module.exports = __webpack_public_path__ + "img/worksheet-maths-question.9a05c83.png";